<template>
  <v-app>
    <v-app-bar app flat color="surface">
      <!-- Desktop Navigation -->
      <v-container class="d-none d-sm-flex align-center app-nav">
        <router-link to="/" class="nav-brand text-accent">Schreinerei M²</router-link>
        <v-spacer></v-spacer>
        <router-link to="/" class="nav-link text-primary">Home</router-link>
        <router-link to="/leistungen" class="nav-link text-primary"
          >Leistungen</router-link
        >
        <router-link to="/products" class="nav-link text-primary">Arbeiten</router-link>
        <router-link to="/about" class="nav-link text-primary">Team</router-link>
        <router-link to="/contact" class="nav-link text-primary">Kontakt</router-link>
      </v-container>
      <!-- Mobile -->
      <v-app-bar-nav-icon
        class="d-sm-none text-primary"
        @click="drawer = !drawer"
      ></v-app-bar-nav-icon>
      <v-spacer class="d-sm-none"></v-spacer>
      <router-link to="/" class="d-sm-none nav-brand text-accent pr-4"
        >Schreinerei M²</router-link
      >
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" temporary class="bg-primary">
      <v-list nav>
        <v-list-item to="/" @click="drawer = false">
          <v-list-item-title class="text-accent">Home</v-list-item-title>
        </v-list-item>
        <v-list-item to="/leistungen" @click="drawer = false">
          <v-list-item-title class="text-accent">Leistungen</v-list-item-title>
        </v-list-item>
        <v-list-item to="/products" @click="drawer = false">
          <v-list-item-title class="text-accent">Arbeiten</v-list-item-title>
        </v-list-item>
        <v-list-item to="/about" @click="drawer = false">
          <v-list-item-title class="text-accent">Team</v-list-item-title>
        </v-list-item>
        <v-list-item to="/contact" @click="drawer = false">
          <v-list-item-title class="text-accent">Kontakt</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <div id="content">
        <router-view></router-view>
      </div>
    </v-main>

    <v-footer class="bg-primary pa-6">
      <v-container class="text-center app-nav">
        <v-btn
          v-for="social in socials"
          :key="social.icon"
          class="text-accent"
          variant="text"
          icon
          :href="social.url"
          target="_blank"
        >
          <v-icon size="24px">{{ social.icon }}</v-icon>
        </v-btn>
        <div class="mt-2">
          <strong class="text-accent">Schreinerei M²</strong>
        </div>
        <small class="text-accent"> Email: info@schreinereim2.de </small>
        <br />
        <small class="footer-links mt-2">
          <router-link to="/impressum" class="footer-link">Impressum</router-link>
          <span class="footer-divider">|</span>
          <router-link to="/datenschutz" class="footer-link">Datenschutz</router-link>
          <span class="footer-divider">|</span>
          <router-link to="/einzugsgebiet" class="footer-link">Einzugsgebiet</router-link>
        </small>
        <br />
        <small class="text-accent" style="opacity: 0.5">
          Website by
          <a
            class="text-decoration-none text-accent"
            href="https://github.com/djoas"
            target="_blank"
            >djoas</a
          >
          &amp;
          <a
            class="text-decoration-none text-accent"
            href="https://github.com/ljo87"
            target="_blank"
            >ljo87</a
          >
          2026 ©
        </small>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data: () => ({
    drawer: false,
    socials: {
      instagram: {
        icon: "mdi-instagram",
        url: "https://www.instagram.com/schreinerei_m_hoch2/",
      },
    },
  }),
};
</script>

<style>
#content {
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  padding: 0 16px;
}

@media screen and (min-width: 960px) {
  #content {
    padding: 0 32px;
  }
}

.app-nav {
  max-width: 1200px;
}

.nav-brand {
  font-family: "ManropeLight", Arial, Helvetica, sans-serif;
  font-size: 1.25rem;
  font-weight: 700;
  text-decoration: none;
}

.nav-link {
  text-decoration: none;
  font-family: "ManropeLight", Arial, Helvetica, sans-serif;
  font-size: 0.9rem;
  margin-left: 1.5rem;
  opacity: 0.8;
  transition: opacity 0.2s;
}

.nav-link:hover {
  opacity: 1;
}

.footer-links {
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 4px;
}

.footer-link {
  color: rgb(var(--v-theme-accent));
  text-decoration: none;
  opacity: 0.7;
}

.footer-link:hover {
  opacity: 1;
  text-decoration: underline;
}

.footer-divider {
  margin: 0 4px;
  color: rgb(var(--v-theme-accent));
  opacity: 0.4;
}

#name {
  font-size: clamp(1.5em, 5vw, 3em);
  font-family: "ManropeLight", Arial, Helvetica, sans-serif;
}

@font-face {
  font-family: "ManropeLight";
  src: url(./assets/fonts/Manrope-Light.ttf) format("truetype");
}
</style>
